const actions = {
  SET_STATE: 'pages/company/flights/SET_STATE',
};

export default actions;
